const setIsServerConnectable = (state, payload) => {
  state.indicators.isServerConnectable = payload
}

const setShowingSlideGrid = (state, payload) => {
  state.indicators.showingSlideGrid = payload
}

const setIsWelcomePopupShowing = (state, payload) => {
  state.indicators.isWelcomePopupShowing = payload
}

const setHasOnboardingV3 = (state, payload) => {
  state.indicators.hasOnboardingV3 = payload
}

const setIsOnboardingV3Showing = (state, payload) => {
  state.indicators.isOnboardingV3Showing = payload
  if (!payload) {
    state.indicators.isRouterViewContentShowing = true
  }
}

export default {
  setIsServerConnectable,
  setShowingSlideGrid,
  setIsWelcomePopupShowing,
  setHasOnboardingV3,
  setIsOnboardingV3Showing,
}
